<app-jumbotron></app-jumbotron>

<div class="container mx-auto">
  <app-company-logo></app-company-logo>
  <app-our-tools></app-our-tools>
</div>

<app-why-us></app-why-us>

<div class="container mx-auto">
  <app-features></app-features>
  <app-download-apps></app-download-apps>
  <app-contact-us-section></app-contact-us-section>
</div>
